/**
 * Design tokens cho dashboard "Commercial Position" (PnL) — theo
 * `plan/PBI_Dashboard.md` §5, RIÊNG header bảng theo template /table-style
 * (`app-table-header-cell`: gradient cream-gold + chữ teal đậm — deviation
 * khỏi navy PBI, chị Đẹp yêu cầu 2026-06-10). Total xanh nhạt, số âm đỏ.
 * Co-locate riêng cho page này (không đụng theme brand chung).
 */
export const PNL_COLORS = {
  headerBg: '#0b3633', // nền header bảng (forest solid — skin Cashflows)
  headerGradient: 'none', // không gradient (forest solid)
  headerText: '#fff', // chữ header (trắng)
  totalRowBg: '#e8f1ee', // nền hàng Total / category (xanh nhạt)
  zebraBg: '#fff', // bỏ zebra — tất cả dòng trắng
  rowBg: '#fff',
  negative: '#d32f2f', // số âm (đỏ)
  positive: '#1a1a1a', // số dương (đen)
  titleText: '#1a1a1a', // tiêu đề card (ink đậm)
  subtitle: '#2563EB', // ngày dưới tiêu đề chính (xanh dương)
  warningCell: '#E53935', // ô cảnh báo (nền đỏ, chữ trắng)
  border: '#dfe3e8', // viền card + bảng
  grid: '#e8ecef', // kẻ ngang dòng body
} as const
